// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__owil1","label":"Tab_label__wCplL","activeTab":"Tab_activeTab__ybguB"};